<template>
  <section class="social-icons">
    <a
      v-for="social in this.social"
      :href="social.source"
      :target="social.target"
    >
      <b-icon :icon="social.icon" size="is-medium"></b-icon>
    </a>
  </section>
</template>

<script>
import BIcon from "buefy/src/components/icon/Icon";

export default {
  name: "Social",
  components: { BIcon },
  data() {
    return {
      social: [
        {
          icon: "linkedin",
          source: "https://www.linkedin.com/in/iamdavidmt",
          target: "_blank",
        },
        {
          icon: "github-circle",
          source: "https://www.github.com/iamdavidmt",
          target: "_blank",
        },
        { icon: "email", source: "mailto:iam@dmt.dev", target: "_blank" },
        { icon: "link", source: "/url", target: "_self" },
      ],
    };
  },
  computed: {},
  methods: {},
};
</script>
